import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const microSiteQuery = groq`*[_type == 'microSite' && currentPathname == $currentPathname][0]{
  ...,
  'MicroSiteHeroContent': {
    microSiteHeroContent,
    title
  },
  CTABanner {
    reference-> ${CTABannerRefProjection}
  }
}`;
